import React, { useEffect, useState } from "react";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import MenusScreen from "../Menus/MenusScreen";
import { Settings } from "@mui/icons-material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LineasPermisoScreen from "./LineasPermisoScreen";

const LineasVentasScreen = ({ idusuario }) => {
  const [listadoLineas, setListadoLineas] = useState([]);

  const [lineaId, setLineaId] = useState(0);
  const [menuTitulo, setMenuTitulo] = useState("");

  const [mostrarMenu, setMostrarMenu] = useState(false);

  useEffect(() => {
    // setLoader({ ...loader, mostrar: true });
    request
      .get(`LineasVentasUsuarios/ListadoLineas`)
      .then((result) => {
        // setLoader({ ...loader, mostrar: false });
        setListadoLineas(result);
      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire("Lineas", JSON.stringify(error), "error");
      });
  }, []);

  const onMostrarMenu = (idlinea, descripcion) => {
    setMostrarMenu(true);
    setLineaId(idlinea);
    setMenuTitulo(descripcion);
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  return (
    <div className="permisos-usuarios-modulos-main-screen-container">
      <div className="permisos-usuarios-modulos-menu-grid">
        <div className="permisos-usuarios-modulos-container scroll-4">
          {listadoLineas.map((item) => (
            <div
              className="permisos-usuarios-modulos-datos"
              key={item.idlinea}
            >
              <div className="permisos-usuarios-modulos-titulos">
                <div
                  className="permisos-usuarios-modulos-titulo-container"
                  onClick={() => onMostrarMenu(item.idlinea, item.descripcion)}
                >
                  <div>
                    <Settings />
                    {capitalizeWords(item.descripcion)}
                  </div>
                  <ArrowForwardIosIcon />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="permisos-usuarios-menu-screen-main">
          {mostrarMenu === true ? (
            <LineasPermisoScreen
              setMostrarMenu={setListadoLineas}
              idlinea={lineaId}
              descripcion={menuTitulo}
              idusuario={idusuario}
            />
          ) : (
            <div />
          )}
        </div>
      </div>
    </div>
  );
};

export default LineasVentasScreen;
